"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Rate = require("./Rate");
Object.keys(_Rate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Rate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Rate[key];
    }
  });
});